import type { AutocompleteRenderInputParams } from "@mui/material";
import { InputAdornment } from "@mui/material";
import { FlagTag } from "components/TitleFormContainer/PriceChannelsStep";
import { ICurrencyOption } from "currenciesList";
import { useTranslation } from "react-i18next";

import AutocompleteFormComponent from "../FormComponent/AutocompleteFormComponent";
import StyledTextField from "../StyledTextField/StyledTextField";
import styles from "./style.module.scss";

interface ICurrencyAutocomplete {
    currenciesList: any;
    control: any;
    controlName: string;
    errors: any;
    vatUsed?: boolean;
    companyCurrency: string;
    required?: boolean;
}

const CurrencyAutocomplete = ({
    currenciesList,
    control,
    controlName,
    errors,
    vatUsed = false,
    companyCurrency = "EUR",
    required = false,
}: ICurrencyAutocomplete) => {
    const [t] = useTranslation();

    const isVatOption = (option: string) => {
        if (option === companyCurrency && vatUsed) return `${option} ${t("VAT")}`;
        else return option;
    };

    // Best would be here to have style modules for CSS but to do this quickly I'm keeping the global >> TODO:
    const renderOptionCurrencies = (props: object, option: { name: string; flag: string; code: string }) => {
        return (
            <li {...props} key={option.code} className={"currencies-title-options-list"}>
                <img src={option.flag} style={{ width: "20px", height: "20px" }} />
                <div className="currencies-info">
                    <span className="currency-name" style={{ fontSize: "12px" }}>
                        {option.name}
                    </span>
                    <span className="currency-code" style={{ fontSize: "12px" }}>
                        {vatUsed ? isVatOption(option.code) : option.code}
                    </span>
                </div>
            </li>
        );
    };

    const renderInputCurrencies = (params: AutocompleteRenderInputParams) => {
        const inputValue = params.inputProps.value == "EUR TTC" ? "EUR" : params.inputProps.value;
        const flag: string | undefined = currenciesList.find((currency) => currency.code == inputValue)?.flag;
        return (
            <StyledTextField
                {...params}
                placeholder={t("NewTitle.SelectCurrency")}
                InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                        <InputAdornment position="end">
                            <FlagTag
                                flagUrl={flag}
                                flagStyle={{
                                    width: "20px",
                                    height: "20px",
                                    opacity: "0.8",
                                    marginLeft: "0.25rem",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            />
                        </InputAdornment>
                    ),
                }}
            />
        );
    };

    return (
        <AutocompleteFormComponent
            className={styles["currency-autocomplete"]}
            label={`${t("NewTitle.Currency")}${required ? "*" : ""}`}
            options={currenciesList}
            renderOptionText={(option: any) => option?.code ?? companyCurrency}
            renderOption={(props, option: any) => renderOptionCurrencies(props, option)}
            defaultFilterOptions
            disableClearable
            renderInput={renderInputCurrencies}
            control={control}
            controlName={controlName}
            error={errors[controlName]}
        />
    );
};

export default CurrencyAutocomplete;
